import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import withStyles from 'react-jss'
import { withTranslation } from 'react-i18next'
import compose from '@shopify/react-compose'
import { Link } from 'react-router-dom'

import { Button, ContentBox, TextInput, CheckboxInput, FormError, Separator, PortalForm, withConfiguration } from '@portal/kit/pkg/components'
import PageTitle from './page-title'
import MseButton from './mse-button'

import loginStyles from './login-style'

const Login = ({ classes, external_error_code, handleSubmit, portalConfiguration, submitError, t }) => {
  const isFacHabitat = portalConfiguration.tag === 'fachabitat' ;

  return (
    <Fragment>
      <PageTitle i18nKey='nav.selfcare_title' />
      <ContentBox className={classes.loginForm}>
        <PortalForm onSubmit={handleSubmit}>
          <h1 className={classes.title}>{t('login.title')}</h1>
          {
            submitError && <FormError message={submitError} />
          }
          <TextInput name="email" label={t('login.email')} />
          <TextInput name="password" label={t('login.password')} type="password" />
          <div className={classes.loginButtons}>
            <div className={classes.rememberMe}>
              <CheckboxInput name="remember" label={t('login.remember-me')} />
            </div>
            <Button type="submit">{t('login.submit')}</Button>
          </div>
        </PortalForm>
        {portalConfiguration.tag === 'planetcampus' &&
          <Fragment>
            <Separator orWording={t('portal.home.or')} />
            <MseButton external_error_code={external_error_code} />
          </Fragment>
        }
      </ContentBox>
      {
        !isFacHabitat &&
          <p className={classes.passwordRecovery}>
            <Link to="/login/password-recovery" className={classes.passwordRecoveryLink}>{t('login.password_forgotten')}</Link>
          </p>
      }
    </Fragment>
  )
}

Login.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  portalConfiguration: PropTypes.object.isRequired,
  submitError: PropTypes.string,
  external_error_code: PropTypes.string,
}

export default compose(
  withStyles(loginStyles),
  withTranslation(),
  withConfiguration,
)(Login)
